/**
 * Author: BaiJiFeiLong@gmail.com
 * Datetime: 2017/5/13 下午6:00
 */

import React from 'react'

export default ({text}) => <b>{text}</b>




// WEBPACK FOOTER //
// src/components/Text.js